import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const checkboxSelector = '.js-checkbox';
	const checkbox = document.querySelectorAll(checkboxSelector);

	if (!checkbox.length) {
		return;
	}

	const { Checkbox } = await import('./checkbox');

	checkbox.forEach((checkboxElem) => {
		const checkbox = new Checkbox(checkboxElem);
		checkbox.init();
	});
});
